"use client";

import type React from "react";
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, X } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface PreOrderSearchProps {
  onSearch: (searchTerm: string) => void;
  searchTerm: string;
}

export function PreOrderSearch({ onSearch, searchTerm }: PreOrderSearchProps) {
  const [inputValue, setInputValue] = useState(searchTerm);
  const [error, setError] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(inputValue.trim());
  };

  const handleClear = () => {
    setInputValue("");
    onSearch("");
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    setError("");
  };

  return (
    <Card className="mb-6 border-0 shadow-sm">
      <CardContent className="pt-4 pb-4">
        <form
          onSubmit={handleSearch}
          className="flex flex-col gap-3 sm:flex-row sm:items-center"
        >
          <div className="relative flex-1 w-full">
            <Input
              placeholder="Buscar pré-pedido por código..."
              value={inputValue}
              onChange={handleChange}
              className={`border-gray-200 h-9 pr-8 ${
                error ? "border-red-300" : ""
              }`}
            />
            {inputValue && (
              <button
                type="button"
                onClick={handleClear}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <X className="h-4 w-4" />
              </button>
            )}
            {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
          </div>
          <Button
            type="submit"
            variant="outline"
            className="gap-2 h-9 border-gray-200 w-full sm:w-auto justify-center"
          >
            <Search className="h-4 w-4" />
            Buscar
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
